import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=7d23e1be&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d23e1be')) {
      api.createRecord('7d23e1be', component.options)
    } else {
      api.reload('7d23e1be', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=7d23e1be&", function () {
      api.rerender('7d23e1be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2luJhc2Dxt8VE/JS/comp/IncreaseNumber.vue"
export default component.exports